export const EMAIL = 'email';
export const HASH = 'hash';
export const CONFIRM_VALUE = 'value';
export const NAME = 'name';
export const PHONE = 'phone';
export const LOCALE = 'locale';
